import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { GetVehicleCondition } from "../../../Components/Tables/Vehicles/GetVehicleCondition";
import instance from "../../../Interceptor/api_instance";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";

const PendingTaskEdit = ({ task, setData, close }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [responseModal, setResponseModal] = useState(null);
  const [formData, setFormData] = useState({
    status: task.status,
    notes: task.notes,
    employee_pin: null,
  });

  const update = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await instance.patch(
        `safety/maintenance-tasks/${task.id}/`,
        formData
      );
      if (res.status === 200) {
        // Expect the updated task in the response in key "task"
        const updatedTask = res.data.task;

        setData((prev) => {
          // Remove if completed
          if (updatedTask.status === "completed") {
            return prev.filter((t) => t.id !== updatedTask.id);
          }

          // Otherwise, just update the one task
          return prev.map((t) =>
            t.id === updatedTask.id
              ? {
                  ...t,
                  status: updatedTask.status,
                  notes: updatedTask.notes,
                }
              : t
          );
        });
        close();
      }
    } catch (err) {
      console.error(err);
      setResponseModal({
        status: t("forms.type.error"),
        message: err,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="page-mask page-mask-animation">
      {responseModal && (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={() => setResponseModal(null)}
        />
      )}
      <div className="edit-modal">
        <h2 className="global-h2 black">
          {t("forms.type.maintenance-report.edit-task")}
        </h2>
        <div className="gray">
          {t("yard-tables.table-columns.unit")}: {task.maintenance_report.unit}
        </div>
        <div className="gray">
          {t("yard-tables.table-columns.description")}: {task.description}
        </div>
        <div className="gray">
          {t("yard-tables.table-columns.priority")}:{" "}
          <GetVehicleCondition condition={task.maintenance_report.priority} />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-block">
            <label className="required">
              {t("yard-tables.table-columns.status")}
            </label>
            <div className="input-cont">
              <select
                name="status"
                className="text-input"
                value={formData.status}
                onChange={update}
              >
                <option value="pending">
                  {t("forms.type.maintenance-report.status-options.pending")}
                </option>
                <option value="waiting-parts">
                  {t("forms.type.maintenance-report.status-options.waiting-parts")}
                </option>
                <option value="in-progress">
                  {t(
                    "forms.type.maintenance-report.status-options.in-progress"
                  )}
                </option>
                <option value="completed">
                  {t("forms.type.maintenance-report.status-options.completed")}
                </option>
              </select>
            </div>
          </div>
          <div className="form-block">
            <label
              className={formData.status === "completed" ? "required" : ""}
            >
              {t("forms.type.vehicle.labels.notes")}
            </label>
            <div className="input-cont">
              <textarea
                name="notes"
                className="text-input"
                onChange={update}
                required={formData.status === "completed"}
              >
                {formData.notes}
              </textarea>
            </div>
          </div>
          <div className="form-block">
            <label className="required">Pin #</label>
            <div className="input-cont">
              <input
                type="password"
                name="employee_pin"
                className="text-input"
                value={formData.employee_pin}
                onChange={update}
                required
              />
            </div>
          </div>
          <div className="full-cont">
            {loading ? (
              <Spinner />
            ) : (
              <>
                <button className="change-pwd-btn all-btn" type="submit">
                  {t("buttons.submit")}
                </button>
                <button
                  className="cancel-btn all-btn"
                  type="button"
                  onClick={close}
                >
                  {t("buttons.cancel")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PendingTaskEdit;
